

























    import { Config } from "@/model/config";
	import { ProductListFilter } from "@/model/product-list-filter";
	import Vue from "vue";
    import {Util} from "@/util/util";
    import IconArrowCircleRight from "@/assets/img/icons/icon-arrow-circle-right.svg";
    import IconArrowCircleLeft from "@/assets/img/icons/icon-arrow-circle-left.svg";

	export default Vue.extend({
		name: "Paginator",
        components: {
            IconArrowCircleRight,
            IconArrowCircleLeft
        },
		props: {
			activeFilter: {
				type: Object as () => ProductListFilter,
				required: true
			},
			totalPages: {
				type: Number,
				required: true
			}
		},
        data() {
            return <{
                config: Config
            }>{
                config: Util.getConfig(),
            };
        },
		computed: {
			currentPage() {
				return this.activeFilter.getPage();
			}
		},
		watch: {
			totalPages() {
			}
		},
		mounted(): void {
		},
		methods: {
			getUrlForPageNumber(pageNumber: number): string {
				return this.activeFilter.clone()
					.setPage(pageNumber)
					.getUrl();
			}
		}
	});
